// extracted by mini-css-extract-plugin
module.exports = {"description":"ConfirmContractSign_description__31TwA"};